import Module from '../classes/Module';
import { app, navigation } from '../utils/store';

export class Navigation extends Module {
    constructor() {
        super({
            element: '[data-navigation]',
            elements: {
                statusbar: '#statusbar',
                actions: '#actions',
                search: '[data-search]',
                language: '#select-language',
                account: '#account',
                cart: '#cart',
                menu: '[data-navigation-menu]',
                products: '[href="#menu-products"]',
                stores: '[href="#menu-stores"]',
            }
        })
    }

    create() {
        super.create()

        app.nav = this.element
        app.root.style.setProperty('--window-height', `${window.innerHeight}px`)
        app.root.style.setProperty('--window-width', `${window.innerWidth}px`)
        app.root.style.setProperty('--navigation-height', `${app.nav.clientHeight}px`)
        if(app.nav.querySelector('.navbar-menu')) {
            app.root.style.setProperty('--navbar-menu-height', `${app.nav.querySelector('.navbar-menu').clientHeight}px`)
        }

        if(app.nav.querySelector('.statusbar')) {
            app.root.style.setProperty('--statusbar-height', `${app.nav.querySelector('.statusbar').clientHeight}px`)
        }

        app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)

        if(this.elements.menu) { this.createMenu() }
        if(this.elements.language) { this.createLanguage() }
        if(this.elements.account) { this.createAccount() }
        if(this.elements.cart) { this.createCart() }
        if(this.elements.products) { this.createProducts() }
        if(this.elements.stores) { this.createStores() }
    }

    createMenu(actions = this.elements.actions) {
        const toggler = actions.querySelector('#menu-toggler')

        if(toggler){
            toggler.onclick = (event) => {
                event.preventDefault()
                event.stopPropagation()

                if(navigation.isOpen){
                    app.body.classList.remove('navigation--open')
                    navigation.isOpen = false
                    navigation.current = null
                } else {
                    app.body.classList.add('navigation--open')
                    navigation.isOpen = true
                    navigation.current = this.elements.menu
                }
            }
        }
    }

    async createLanguage(actions = this.elements.actions) {
        let language = {
            toggler: actions.querySelector('#language-toggler'),
            closer: document.querySelector('[data-modal-language] .btn-close')
        }
        
        if(language.toggler){
            await import(
                /* webpackChunkName: "modals" */
                /* webpackPrefetch: true */
                '../classes/Modal'
            ).then((module) => {
                new module.ModalManager.toggle(language.toggler)
                new module.ModalManager.close(language.closer)
            }).catch(error => {
                console.warn('Error loading module:', error);
            })
        }
    }

    createAccount(actions = this.elements.actions) {
        const toggler = actions.querySelector('#account-toggler')
    }

    createCart(actions = this.elements.actions) {
        const toggler = actions.querySelector('#cart-toggler')
    }

    createProducts(toggler = this.elements.products) {
        let menu, mega

        if(toggler){
            menu = {
                toggler: toggler,
                submenu: toggler.parentNode.querySelector('.dropdown-menu')
            }

            if(menu.submenu){
                mega =  {
                    togglers: menu.submenu.querySelectorAll('.tease-menu'), 
                    menu: []
                }

                for(const toggler of mega.togglers){
                    let menu = app.nav.querySelector(`[data-toggler="${toggler.getAttribute('href')}"]`)
                    mega.menu.push(menu)

                    let backlink = menu.querySelector('.btn-backlink')


                    if(menu){
                        menu.style.setProperty('--menu-height', `${menu.clientHeight}px`)
                        
                        toggler.onclick = (event) => {
                            menu.style.setProperty('--parent-height', `${toggler.parentNode.parentNode.clientHeight}px`)

                            event.preventDefault()
                            event.stopPropagation()
                            
                            if(menu.classList.contains('active')){
                                app.root.classList.remove('navigation-mega-menu--open')
                                menu.classList.remove('active')
                                toggler.classList.remove('active')
                            } else {
                                mega.menu.forEach((entry) => { entry.classList.remove('active') })
                                mega.togglers.forEach((entry) => { entry.classList.remove('active') })
                                app.root.classList.add('navigation-mega-menu--open')
                                menu.classList.add('active')
                                toggler.classList.add('active')
                            }                 
                        }

                        if(backlink){
                            backlink.onclick = (event) => {
                                event.preventDefault()
                                event.stopPropagation()
                                app.root.classList.remove('navigation-mega-menu--open')
                                mega.menu.forEach((entry) => { entry.classList.remove('active') })
                                mega.togglers.forEach((entry) => { entry.classList.remove('active') })
                            }
                        }
                    }
                }

                if(mega.menu.length > 0){
                    toggler.addEventListener('click', (event) => {
                        app.root.classList.remove('navigation-mega-menu--open')
                        mega.menu.forEach((entry) => { entry.classList.remove('active') })
                        mega.togglers.forEach((entry) => { entry.classList.remove('active') })   
                    })

                    let menuToggler = app.nav.querySelector('#menu-toggler')
                    if(menuToggler){
                        menuToggler.addEventListener('click', (event) => {
                            app.root.classList.remove('navigation-mega-menu--open')
                            mega.menu.forEach((entry) => { entry.classList.remove('active') })
                            mega.togglers.forEach((entry) => { entry.classList.remove('active') })   
                        })
                    }

                }
            }
        }
    }

    createStores(toggler = this.elements.stores) {
        console.log(toggler)
    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            app.root.style.setProperty('--window-height', `${window.innerHeight}px`)
            app.root.style.setProperty('--window-width', `${window.innerWidth}px`)
            app.root.style.setProperty('--navigation-height', `${app.nav.clientHeight}px`)

            if(app.nav.querySelector('.navbar-menu')) {
                app.root.style.setProperty('--navbar-menu-height', `${app.nav.querySelector('.navbar-menu').clientHeight}px`)
            }

            if(app.nav.querySelector('.statusbar')) {
                app.root.style.setProperty('--statusbar-height', `${app.nav.querySelector('.statusbar').clientHeight}px`)
            }

            if(navigation.isOpen){
                app.body.classList.remove('navigation--open')
                navigation.isOpen = false
                navigation.current = null
            }
        })

        window.visualViewport.addEventListener('resize', () => {
            app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)
        })

        window.addEventListener('scroll', () => {
            if(app.nav.querySelector('.statusbar')) {
                if(window.scrollY > app.nav.querySelector('.statusbar').clientHeight){
                    app.body.classList.add('statusbar--invisible')
                } else {
                    app.body.classList.remove('statusbar--invisible')
                }
            }
        })
    }
}

export class Footer extends Module {
    constructor() {
        super({
            element: 'footer', 
            elements: {
                language: '#select-language-footer',
            }
        })
    }

    create() {
        super.create()

        if(this.elements.language) { this.createLanguage() }
        this.createNewsletter()
    }

    async createLanguage(container = this.elements.language) {
        if(!container) return
        
        let language = {
            toggler: container.querySelector('#language-toggler-footer'),
            closer: document.querySelector('[data-modal-language] .btn-close')
        }
        
        if(language.toggler){
            await import(
                /* webpackChunkName: "modals" */
                /* webpackPrefetch: true */
                '../classes/Modal'
            ).then((module) => {
                new module.ModalManager.toggle(language.toggler)
                new module.ModalManager.close(language.closer)
            }).catch(error => {
                console.warn('Error loading module:', error);
            })
        }
    }

    createNewsletter() {
        const form = this.element ? this.element.querySelector('#newsletter') : null
        if (!form) return

        const emailInput = form.querySelector('input[name="email"]')
        const nonceInput = form.querySelector('input[name="nonce"]')
        const submitButton = form.querySelector('button[type="submit"]')
        const feedback = form.querySelector('#newsletter-footer-feedback')

        if (!emailInput || !nonceInput || !submitButton) return

        let ajaxUrl = `${window.location.origin}/wp-admin/admin-ajax.php`
        try {
            const localizedAjaxUrl = window.proficolorAccountModify?.ajaxUrl
            if (localizedAjaxUrl && typeof localizedAjaxUrl === 'string') {
                ajaxUrl = new URL(localizedAjaxUrl, window.location.origin).toString()
            }
        } catch (error) {
            // Keep default fallback URL
        }

        form.addEventListener('submit', async (event) => {
            event.preventDefault()

            const formData = new FormData()
            formData.append('action', 'proficolor_subscribe_newsletter')
            formData.append('nonce', nonceInput.value)
            formData.append('newsletter_email', emailInput.value)

            submitButton.disabled = true

            try {
                const response = await fetch(ajaxUrl, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                })

                const result = await response.json()
                if (!response.ok || !result.success) {
                    throw new Error(result?.data?.message || 'Request failed')
                }

                if (feedback) {
                    feedback.textContent = result.data.message || ''
                    feedback.hidden = false
                }

                form.classList.add('is-subscribed')
                emailInput.disabled = true
                submitButton.textContent = 'Iscritto'
            } catch (error) {
                if (feedback) {
                    feedback.textContent = error?.message || 'Errore durante l\'iscrizione alla newsletter.'
                    feedback.hidden = false
                }
            } finally {
                if (!form.classList.contains('is-subscribed')) {
                    submitButton.disabled = false
                }
            }
        })
    }
}
